import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import './../../styles/ResetPasswordModal.css';
import userService from './../../services/UserService';

export default function ResetPasswordModal({ onClose }) {
  
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await userService.resetPassword({
        oldPassword,
        newPassword,
      });

      if (res?.isSuccess) {
        setSuccess(true);
      } else {
        setError(res?.message || `Ensure your old password is correct and your new one meets the requirements.`);
      }
    } catch (err) {
      setError(`Ensure your old password is correct and your new one meets the requirements.`);
    } finally {
      setLoading(false);
    }
  };

  return ReactDOM.createPortal(
    <div className="rpm-overlay">
      <div className="rpm-modal">
        <h2>Change Password</h2>
        <p>
          Your new password must be at least 12 characters long and include at least one uppercase letter,
          one lowercase letter, one number, and one special character (!@#$%^&*).
        </p>

        {error && <p className="rpm-error">{error}</p>}

        <form onSubmit={handleSubmit}>
          <label>
            Old Password
            <div className="rpm-input-group">
              <input
                type="password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                required
                disabled={loading || success}
              />
              {success && (
                <FontAwesomeIcon icon={faCheck} className="rpm-success-icon tick-fonts" />
              )}
            </div>
          </label>

          <label>
            New Password
            <div className="rpm-input-group">
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                disabled={loading || success}
              />
              {success && (
                <FontAwesomeIcon icon={faCheck} className="rpm-success-icon tick-fonts" />
              )}
            </div>
          </label>

          <div className="rpm-buttons">
            <button type="button" onClick={onClose} disabled={loading}>
              {success ? 'Close' : 'Cancel'}
            </button>

            {!success && (
              <button type="submit" disabled={loading}>
                {loading ? 'Saving…' : 'Submit'}
              </button>
            )}
          </div>

         
        </form>
      </div>
    </div>,
    document.body
  );
}
